import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence, useInView } from 'framer-motion';
import { StarIcon, QuoteIcon, ChevronLeftIcon, ChevronRightIcon, TrendingUpIcon, UsersIcon, AwardIcon, DollarSignIcon } from 'lucide-react';
const testimonials = [{
  name: 'Tolu Okafor',
  role: 'Product Designer',
  image: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=200&h=200&fit=crop&crop=face',
  content: 'LeaDe Academy completely transformed my career. I went from a junior designer to landing my dream job in just 6 months. The curriculum is incredibly practical and the mentorship is world-class.',
  rating: 5,
  outcome: {
    label: 'Time to dream job',
    value: '6 months'
  }
}, {
  name: 'Sarah Mitchell',
  role: 'Senior Product Designer',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop&crop=face',
  content: "I was skeptical at first — I'd tried other bootcamps that overpromised. LeaDe delivered on every front. The structured curriculum and real-world briefs gave me exactly what I needed to break into a top tech company.",
  rating: 5,
  outcome: {
    label: 'Time to new role',
    value: '4 months'
  }
}, {
  name: 'Emeka Nwosu',
  role: 'Senior UX Designer',
  image: 'https://images.unsplash.com/photo-1506277886164-e25aa3f4ef7f?w=200&h=200&fit=crop&crop=face',
  content: "The AI-powered design module alone was worth the entire investment. I've 10x'd my productivity and the quality of my work has never been better. Highly recommend to anyone serious about design.",
  rating: 5,
  outcome: {
    label: 'Productivity increase',
    value: '10x'
  }
}, {
  name: 'Marcus Weber',
  role: 'Product Designer',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=face',
  content: "Coming from a graphic design background, I needed to transition into UX. LeaDe's program bridged that gap perfectly. The mentors understood exactly where I was coming from and pushed me in the right direction.",
  rating: 5,
  outcome: {
    label: 'Career transition',
    value: 'Graphic → UX'
  }
}, {
  name: 'Adaeze Ibe',
  role: 'Design Lead',
  image: 'https://images.unsplash.com/photo-1589156280159-27698a70f29e?w=200&h=200&fit=crop&crop=face',
  content: "What sets LeaDe apart is the community. The connections I made during the cohort have been invaluable. I've collaborated with fellow graduates on multiple projects since graduating.",
  rating: 5,
  outcome: {
    label: 'Team members hired',
    value: '3 grads'
  }
}, {
  name: 'Emma Thornton',
  role: 'UX Lead',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&fit=crop&crop=face',
  content: 'The depth of the curriculum surprised me. We covered everything from research methods to design systems and handoff. I felt genuinely prepared for the job, not just interview-ready. My team noticed the difference immediately.',
  rating: 5,
  outcome: {
    label: 'Promotion timeline',
    value: '3 months'
  }
}, {
  name: 'Bolu Fashola',
  role: 'Freelance Product Designer',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=face',
  content: 'As a self-taught designer, I had gaps in my knowledge. LeaDe filled those gaps and gave me the confidence to charge premium rates. My income has tripled since completing the program.',
  rating: 5,
  outcome: {
    label: 'Income increase',
    value: '3x salary'
  }
}, {
  name: 'James Callahan',
  role: 'Freelance UX Designer',
  image: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=200&h=200&fit=crop&crop=face',
  content: 'LeaDe gave me the business acumen I was missing as a freelancer. Learning how to present design decisions to stakeholders and price my work confidently has been a game-changer. My client roster doubled within two months.',
  rating: 5,
  outcome: {
    label: 'Client growth',
    value: '2x clients'
  }
}, {
  name: 'Ngozi Eze',
  role: 'Product Designer',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&crop=face',
  content: "The portfolio projects are incredibly well-designed. They're challenging enough to push you but structured enough that you actually finish them. My portfolio went from mediocre to exceptional.",
  rating: 5,
  outcome: {
    label: 'Portfolio quality',
    value: 'Exceptional'
  }
}, {
  name: 'Sofia Andersson',
  role: 'Product Designer',
  image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=200&h=200&fit=crop&crop=face',
  content: 'I joined LeaDe while working full-time and the async-friendly format made it possible. The community Slack was incredibly active and supportive. I never felt alone in the process, even across different time zones.',
  rating: 5,
  outcome: {
    label: 'Completed while',
    value: 'Working FT'
  }
}, {
  name: 'Chidi Obi',
  role: 'UX Designer',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop&crop=face',
  content: "I've taken many design courses, but LeaDe is in a different league. The live sessions with industry mentors and the career support made all the difference in landing my role.",
  rating: 5,
  outcome: {
    label: 'Previous courses',
    value: 'Many'
  }
}];
const stats = [{
  label: 'Designers Enrolled',
  value: '100+',
  icon: UsersIcon
}, {
  label: 'Average Rating',
  value: '4.9/5',
  icon: StarIcon
}, {
  label: 'Job Placement',
  value: '94%',
  icon: AwardIcon
}, {
  label: 'Avg Salary Increase',
  value: '$28k',
  icon: DollarSignIcon
}];
export function TestimonialsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [direction, setDirection] = useState(0);
  // Auto-advance logic
  useEffect(() => {
    if (isHovered) return;
    const timer = setInterval(() => {
      setDirection(1);
      setActiveIndex(prev => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [isHovered]);
  const handleNext = () => {
    setDirection(1);
    setActiveIndex(prev => (prev + 1) % testimonials.length);
  };
  const handlePrev = () => {
    setDirection(-1);
    setActiveIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  const handleDotClick = (index: number) => {
    setDirection(index > activeIndex ? 1 : -1);
    setActiveIndex(index);
  };
  const variants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 50 : -50,
      opacity: 0
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      zIndex: 0,
      x: direction < 0 ? 50 : -50,
      opacity: 0
    })
  };
  return <section id="testimonials" className="py-24 bg-dark-800 relative overflow-hidden" data-id="element-495">
      {/* Background accent */}
      <div className="absolute top-1/2 left-0 w-96 h-96 bg-brand-yellow/5 rounded-full blur-3xl -translate-y-1/2 pointer-events-none" data-id="element-496" />
      <div className="absolute top-1/2 right-0 w-96 h-96 bg-brand-yellow/5 rounded-full blur-3xl -translate-y-1/2 pointer-events-none" data-id="element-497" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" ref={ref} data-id="element-498">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-499">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5
        }} className="inline-block text-brand-yellow text-sm font-semibold tracking-wider uppercase mb-4" data-id="element-500">
            Success Stories
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-4xl sm:text-5xl font-bold text-white mb-6" data-id="element-501">
            Join 100+ designers who
            <br data-id="element-502" />
            <span className="text-gradient-yellow" data-id="element-503">
              transformed their careers
            </span>
          </motion.h2>
        </div>

        {/* Featured Testimonial Carousel */}
        <div className="relative max-w-5xl mx-auto mb-20" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-id="element-504">
          {/* Navigation Buttons */}
          <button onClick={handlePrev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-12 z-20 p-2 rounded-full bg-white/5 border border-white/10 text-white hover:bg-white/10 hover:scale-110 transition-all duration-200 hidden md:flex" aria-label="Previous testimonial" data-id="element-505">
            <ChevronLeftIcon className="w-6 h-6" data-id="element-506" />
          </button>
          <button onClick={handleNext} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-12 z-20 p-2 rounded-full bg-white/5 border border-white/10 text-white hover:bg-white/10 hover:scale-110 transition-all duration-200 hidden md:flex" aria-label="Next testimonial" data-id="element-507">
            <ChevronRightIcon className="w-6 h-6" data-id="element-508" />
          </button>

          <div className="relative overflow-hidden min-h-[400px] md:min-h-[320px]" data-id="element-509">
            <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-510">
              <motion.div key={activeIndex} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
              x: {
                type: 'spring',
                stiffness: 300,
                damping: 30
              },
              opacity: {
                duration: 0.2
              }
            }} className="w-full" data-id="element-511">
                <div className="bg-dark-700/50 border border-white/10 rounded-2xl p-8 md:p-12 backdrop-blur-sm" data-id="element-512">
                  <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center" data-id="element-513">
                    {/* Left Side: Content */}
                    <div className="flex-1 text-center md:text-left" data-id="element-514">
                      <QuoteIcon className="w-12 h-12 text-brand-yellow/20 mb-6 mx-auto md:mx-0" data-id="element-515" />

                      <p className="md:text-2xl text-white font-medium mb-8 text-[16px]" data-id="element-516">
                        "{testimonials[activeIndex].content}"
                      </p>

                      <div className="flex items-center justify-center md:justify-start gap-4" data-id="element-517">
                        <div className="text-left" data-id="element-518">
                          <div className="font-bold text-white text-lg" data-id="element-519">
                            {testimonials[activeIndex].name}
                          </div>
                          <div className="text-brand-yellow/80 text-sm font-medium" data-id="element-520">
                            {testimonials[activeIndex].role}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Right Side: Outcome Card */}
                    <div className="w-full md:w-auto flex-shrink-0" data-id="element-521"></div>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Thumbnails Navigation */}
          <div className="mt-12" data-id="element-522">
            <div className="flex overflow-x-auto gap-4 pb-2 scrollbar-hide" style={{
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }} data-id="element-523">
              {testimonials.map((t, index) => <button key={index} onClick={() => handleDotClick(index)} className={`group relative flex-shrink-0 flex items-center gap-3 pl-3 pr-4 py-1 rounded-full transition-all duration-300 ${index === activeIndex ? 'bg-white/10 ring-1 ring-brand-yellow/50' : 'bg-transparent hover:bg-white/5'}`} data-id="element-524">
                  <span className={`text-sm font-medium transition-colors duration-300 ${index === activeIndex ? 'text-white' : 'text-gray-500 group-hover:text-gray-300'}`} data-id="element-525">
                    {t.name}
                  </span>

                  {/* Progress Bar for Active Item */}
                  {index === activeIndex && !isHovered && <motion.div className="absolute bottom-0 left-3 right-3 h-[2px] bg-brand-yellow rounded-full" layoutId="progress" initial={{
                width: '0%'
              }} animate={{
                width: '100%'
              }} transition={{
                duration: 5,
                ease: 'linear'
              }} data-id="element-526" />}
                </button>)}
            </div>
          </div>
        </div>

        {/* Stats Bar */}
      </div>
    </section>;
}